module.exports = __webpack_public_path__ + "media/skylikeDawn.6627a250.mp3";